import { render } from "./header-caintainer.vue?vue&type=template&id=54904bbe&scoped=true&lang=true"
import script from "./header-caintainer.vue?vue&type=script&lang=js"
export * from "./header-caintainer.vue?vue&type=script&lang=js"

import "./header-caintainer.vue?vue&type=style&index=0&id=54904bbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54904bbe"]])

export default __exports__